import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiCommentComponent } from '@components/ui-comment/ui-comment.component';
import {
    ICommentChangeEvent,
    ICommentEditEvent,
} from '@components/ui-comment/ui-comment.model';
import {
    IComment,
    IUser,
} from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services';
import { ODataService } from '@services/generics/odata.service';

@Component({
    selector: 'ui-comments',
    templateUrl: './ui-comments.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCommentsComponent {
    @Input()
    public service!: ODataService<IComment, number>;
    @Input()
    public comments!: Array<IComment>;
    @Input()
    public editPermission?: string;

    @Output()
    public removed = new EventEmitter<void>();

    public currentUserId!: IUser['id'];

    @ViewChildren(UiCommentComponent)
    protected _children?: QueryList<UiCommentComponent>;

    constructor(
        appState: AppStateFacade,
        private _modalService: ModalService,
        private _translateService: TranslateService,
    ) {
        this.currentUserId = appState.user.value!.id;
    }

    onEditingComment(event: ICommentEditEvent) {
        if (!this._children) { return; }
        if (this._children.some(child => child.dirty)) {
            this._modalService.onConfirm(null,
                () => {
                    this._children!.forEach(child => child.cancel());
                    event.continue();
                },
                () => { },
                this._translateService.instant('comments_unsaved_changes_warning'));
        } else {
            this._children.forEach(child => child.cancel());
            event.continue();
        }
    }

    onUpdateComment(event: ICommentChangeEvent) {
        const comment = event.comment;
        this.service.update(comment.id, comment).subscribe(event.success, event.error);
    }

    onDeleteComment(event: ICommentChangeEvent) {
        const comment = event.comment;
        this.service.delete(comment.id).subscribe(
            () => {
                const index = this.comments.indexOf(comment);
                this.comments.splice(index, 1);
                event.success();
                this.removed.emit();
            }, event.error,
        );
    }
}
